'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function RedemptionRedirect({ routes, offerId, referralSource }) {
  let redirectRoute = routes.redirect.offers.replace('{offerId}', offerId);

  if (referralSource) {
    redirectRoute += `?referralSource=${referralSource}`;
  }

  return h(
    'a.redemption-modal-button',
    {
      href: redirectRoute,
      target: '_blank',
      rel: 'noopener',
      'data-bhc': `coupon:${offerId}`,
    },
    h(Translate, 'js.modules.redemption.ShopNow')
  );
}

module.exports = RedemptionRedirect;
